// Solo estos códigos confirman que la credencial guardada ya no sirve.
const INVALID_SAVED_SESSION_CODES = new Set(['AUTH_SAVED_SESSION_INVALID', 'AUTH_SAVED_SESSION_EXPIRED', 'SESSION_EXPIRED']);

export function isInvalidSavedSession(result) {
  return result?.ok === false && INVALID_SAVED_SESSION_CODES.has(result.code);
}
